var angular = require('angular');

export default angular
    .module('asProgressSteps', [])
    .component('asProgressSteps', {
        template: require('./asProgressSteps.component.html'),
        styleUrls: require('./asProgressSteps.component.css'),
        bindToController: true,
        bindings: {
            asProgressSteps: '<'
        }
    });



// WEBPACK FOOTER //
// ./modules/shared/asProgressSteps/asProgressSteps.component.js